"use client";

import { useEffect } from "react";
import { CloudOff } from "lucide-react";
import { Button } from "@/components/ui/Button";
import { EmptyState } from "@/components/ui/EmptyState";

/**
 * What a page shows when something in it throws: a word in Portuguese and a
 * way out, rather than the framework's own page. Loading the page again is
 * the one recovery that always works, since it starts from the server.
 */
export default function ErrorPage({ error }: { error: Error & { digest?: string } }) {
  useEffect(() => {
    console.error(error);
  }, [error]);

  return (
    <EmptyState
      icon={<CloudOff />}
      title="Algo correu mal"
      text="Não conseguimos mostrar esta página. Tenta carregá-la outra vez."
      action={<Button onClick={() => window.location.reload()}>Recarregar</Button>}
    />
  );
}
